export default __webpack_public_path__ + "src/assets/images/plug/smartplug_UK.png?282bab97";